import { render, staticRenderFns } from "./index.vue?vue&type=template&id=709d0b54&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=709d0b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d0b54",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {News: require('/app/components/home/News.vue').default,LiveBlogSummaryBlock: require('/app/components/home/LiveBlogSummaryBlock.vue').default,JustInSidebar: require('/app/components/sidebar/JustInSidebar.vue').default,AdGroup: require('/app/components/sidebar/AdGroup.vue').default,ContentCollections: require('/app/components/home/ContentCollections.vue').default,DayOverview: require('/app/components/home/DayOverview.vue').default})
